<template>
  <discount-blank-form
    submit-label="Добавить скидку"
    :discount="discount"
    :errors="errors"
    form-type="add"
    @submit="processDiscountForm"
  />
</template>

<script>
import helpers from '@/helpers'
import { addDiscount } from '@/services/discount.service'
import discountBlankForm from '@/components/forms/discount/DiscountBlankForm'

export default {
  name: 'discount-add-form',
  components: { discountBlankForm },
  data () {
    return {
      discount: {
        id: null,
        name: '',
        amount: '',
        start_date: '',
        end_date: ''
      },

      errors: {
        discount: {
          id: [],
          name: [],
          amount: [],
          start_date: [],
          end_date: []
        },
        non_field_errors: []
      }
    }
  },
  methods: {
    fillErrors: helpers.fillErrors,

    processDiscountForm () {
      this.addDiscount().then((success) => {
        if (success) {
          this.showMsg('Скидка была успешно добавлена!', 'success', 'Успешно')
          this.$emit('after', true)
        } else {
          this.$emit('after', false)
        }
      })
    },
    addDiscount () {
      return addDiscount(this.discount).then((response) => {
        this.discount = response.data
        this.fillErrors(this.errors.discount, {})
        return true
      }).catch(err => {
        this.fillErrors(this.errors.discount, err.response.data)

        if (this.errors.non_field_errors[0]) {
          this.$parent.$parent.showPopupMsg(this.errors.non_field_errors[0], 'error')
        }

        return false
      })
    },
    showMsg (text, type, title) {
      let foundRoot = false
      let $parent = this.$parent

      while (!foundRoot) {
        console.log($parent)
        if ($parent.$parent.$parent === undefined) {
          foundRoot = true
          $parent.showPopupMsg(text, type, title)
        } else {
          $parent = $parent.$parent
        }
      }
    }
  }
}
</script>


// WEBPACK FOOTER //
// DiscountAddForm.vue?04760a66